import React, { useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.scss'
import { globalSearchActions } from 'srcReact/SearchPage'
import Icon from 'srcReact/components/icons/Icon'

export default function GlobalSearchSuggestionPopin({ isHeader = false, handleSearch, closeModal }) {
  const { t } = useTranslation()
  const containerRef = useRef(null)

  const dispatch = useDispatch()
  const {
    globalSearch: { searchSuggestionList }
  } = useSelector((state) => state)

  useEffect(() => {
    containerRef.current.addEventListener('keydown', handleKeyPress, false)
    return function cleanup() {
      containerRef.current.removeEventListener('keydown', handleKeyPress, false)
    }
  }, [])

  const handleKeyPress = (e) => {
    if (e.key === 'Tab') {
      const focusableElements = containerRef.current.querySelectorAll('button')

      const firstElement = focusableElements[0]
      const lastElement = focusableElements[focusableElements.length - 1]

      if (e.shiftKey && document.activeElement === firstElement) {
        // Shift + Tab, focus the last focusable element
        e.preventDefault()
        lastElement.focus()
      } else if (!e.shiftKey && document.activeElement === lastElement) {
        // Tab, focus the first focusable element
        e.preventDefault()
        firstElement.focus()
      }
    } else if (event.key === 'Escape' && closeModal) {
      closeModal()
    }
  }

  return (
    <div
      id='globalsearch_popin'
      ref={containerRef}
      tabIndex={0}
      className={`${styles.globalSearchSuggestionPopin} ${isHeader && styles.isHeader}`}>
      {searchSuggestionList.length >= 1 &&
        searchSuggestionList.slice(0, 10).map((s, idx) => (
          <button
            aria-label={t('globalSearch.accessibility.suggestedText', { text: s })}
            key={idx}
            //     onKeyDown={handleKeyPress}
            className={styles.searchSuggestion}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => handleSearch(s)}>
            <Icon name='search24' size='large24' />
            <div className={styles.text}>{s}</div>
          </button>
        ))}
    </div>
  )
}
